import GuideLayout, { GuideStep } from './GuideLayout';

const yolYardimSteps: GuideStep[] = [
  { id: 1, title: 'Uygulamaya Giriş', description: 'YolSepetiGO uygulamasını açın ve hesabınıza giriş yapın.', image: '/images/customer-app/1.png' },
  { id: 2, title: 'Yol Yardım Seçin', description: 'Ana ekranda "Yol Yardım" hizmetine tıklayın. Acil durumlar için idealdir.', image: '/images/customer-app/2.png' },
  { id: 3, title: 'Sorun Türü Seçin', description: 'Lastik patladı mı? Akü mü bitti? Yakıt mı lazım? Sorununuzu seçin.', image: '/images/customer-app/3.png' },
  { id: 4, title: 'Konum Paylaşın', description: 'Bulunduğunuz konumu paylaşın. GPS ile otomatik algılanır.', image: '/images/customer-app/4.png' },
  { id: 5, title: 'Fiyatı Görün', description: 'Yol yardım hizmeti için ücret görüntülenir. Onaylayın.', image: '/images/customer-app/5.png' },
  { id: 6, title: 'Yardım Yolda', description: 'Talebiniz onaylandı! En yakın yol yardım ekibi yola çıktı.', image: '/images/customer-app/6.png' },
  { id: 7, title: 'Ödeme Yapın', description: 'Hizmet sonrası güvenli ödeme yapın.', image: '/images/customer-app/7.png' },
  { id: 8, title: 'Ekibi Takip', description: 'Yol yardım ekibini haritada canlı takip edin.', image: '/images/customer-app/8.png' },
];

export default function YolYardimGuidePage() {
  return (
    <GuideLayout
      service="yol-yardim"
      poster={{ src: '/images/services/yol-yardim.jpg', alt: 'Yol yardım hizmeti tanıtımı' }}
      seo={{
        title: 'Yol Yardım Talebi Nasıl Oluşturulur?',
        description: 'YolSepetiGO ile yol yardım talebi nasıl oluşturulur? 8 adımda acil yol yardımı alın.',
        keywords: ['yol yardım', 'lastik değişimi', 'akü takviyesi', 'yakıt ikmali', 'acil yardım'],
      }}
      breadcrumb="Yol Yardım"
      title="Yol Yardım Talebi Nasıl Oluşturulur?"
      subtitle="8 kolay adımda acil yol yardımı alın. Lastik, akü, yakıt - ne olursa olsun yanınızdayız!"
      accent={{
        from: '#16a34a',
        to: '#15803d',
        soft: '#dcfce7',
        border: '#86efac',
        strong: '#166534',
        text: '#14532d',
      }}
      steps={yolYardimSteps}
      tipsTitle="Yol Yardım İpuçları"
      tips={[
        'Lastik patlamasında aracı güvenli bir yere çekin ve dörtlüleri açın.',
        'Akü takviyesi için arabanızın motor hacmini belirtmeniz faydalı olur.',
        'Yakıt ikmali için yakıt türünü (benzin/dizel) doğru seçin.',
        'Gece saatlerinde konumunuzu tarif ederken çevredeki belirgin noktaları kullanın.',
      ]}
      cta={{
        title: 'Acil Yol Yardımı Alın!',
        text: 'Yolda mı kaldınız? Hemen yardım çağırın, en yakın ekibimiz yola çıksın.',
        label: 'Yol Yardım Çağır',
        href: 'https://yolsepetigo.com',
        tone: 'secondary',
      }}
    />
  );
}
